module.exports = __webpack_public_path__ + "img/legume-peas-190x100.31768a5a.jpg";